import { render, staticRenderFns } from "./LeadTable.vue?vue&type=template&id=151866b1&"
import script from "./LeadTable.vue?vue&type=script&lang=js&"
export * from "./LeadTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports